import React from "react";
import Box from "@mui/material/Box";
import BottomCart from "../../../../Components/Widgets/BottomCart";
import Footer from "../../widgets/footer/footer";
import NavBar from "../../../../Components/Widgets/Navbar";
import CartDrawer from "../../../../Components/Widgets/CartDrawer";
import Orders from "../../../../Components/Widgets/User/Orders";

const ExportDefault = (props) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <NavBar {...props} />
      <CartDrawer {...props} />
      <Orders {...props} />
      <Footer {...props} />
      <BottomCart {...props} />
    </Box>
  );
};

export default ExportDefault;
